var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoteBook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 14,
    viewBox: "0 0 12 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.794 0.333984C10.8533 0.333984 12 1.52065 12 3.55398V10.4406C12 12.5073 10.8533 13.6673 8.794 13.6673H3.20667C1.18 13.6673 0 12.5073 0 10.4406V3.55398C0 1.52065 1.18 0.333984 3.20667 0.333984H8.794ZM3.38667 9.49398C3.18667 9.47398 2.99333 9.56732 2.88667 9.74065C2.78 9.90732 2.78 10.1273 2.88667 10.3007C2.99333 10.4673 3.18667 10.5673 3.38667 10.5407H8.61333C8.87933 10.514 9.08 10.2867 9.08 10.0206C9.08 9.74732 8.87933 9.52065 8.61333 9.49398H3.38667ZM8.61333 6.45332H3.38667C3.09933 6.45332 2.86667 6.68732 2.86667 6.97398C2.86667 7.26065 3.09933 7.49398 3.38667 7.49398H8.61333C8.9 7.49398 9.13333 7.26065 9.13333 6.97398C9.13333 6.68732 8.9 6.45332 8.61333 6.45332ZM5.37933 3.43398H3.38667V3.44065C3.09933 3.44065 2.86667 3.67398 2.86667 3.96065C2.86667 4.24732 3.09933 4.48065 3.38667 4.48065H5.37933C5.66667 4.48065 5.9 4.24732 5.9 3.95332C5.9 3.66732 5.66667 3.43398 5.37933 3.43398Z",
    fill: "#7A7A7A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoteBook);
export default __webpack_public_path__ + "static/media/NoteBook.0f29c098b1e4fee07ae02f758c7d76be.svg";
export { ForwardRef as ReactComponent };